import _ from 'lodash'
import { master } from '@/constants/master.js'
const Master = {
  namespaced: true,

  state: {
    master: _.cloneDeep(master),
    years: [],
    // パノラマ送信表示フラグ
    f_panorama: {
      f_homes_panorama: 0, // 0:非表示 1:表示
      f_suumo_panorama_disable: 1, // 0:表示 1:非表示
    },
  },
  getters: {
    getMaster(state) {
      return state.master
    },
    getYears(state) {
      return state.years
    },
    getFilteredYears:
      state =>
      ({ past, future, sort }) => {
        const currentYear = new Date().getFullYear()
        const filtered = state.years.filter(
          item => item.value >= currentYear - past && item.value <= currentYear + future,
        )
        return sort === 'asc' ? [...filtered].reverse() : filtered
      },
    getFPanorama(state) {
      return state.f_panorama
    },
  },
  mutations: {
    setYears(state, years) {
      state.years = years
    },
    setFPanorama(state, panorama) {
      state.f_panorama = panorama
    },
  },
  actions: {},
}

export default Master
